import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=46c824ae&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=46c824ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c824ae",
  null
  
)

export default component.exports